/* istanbul ignore file */
import React from 'react';

function IconPinterest() {
  return /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    className: "icon-pinterest",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      width: 42
    }
  }, /*#__PURE__*/React.createElement("circle", {
    className: "circle-1",
    fill: "#c01603",
    cx: "16",
    cy: "16",
    r: "16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "path-1",
    fill: "#f1f2f2",
    d: "M17.3,21.4c-1.2-0.1-1.7-0.7-2.7-1.3c-0.5,2.7-1.2,5.4-3,6.7c-0.6-4.1,0.9-7.2,1.5-10.5\nc-1.1-1.9,0.1-5.8,2.5-4.8c3,1.2-2.6,7.1,1.1,7.9c3.9,0.8,5.4-6.7,3-9.1c-3.5-3.5-10.1-0.1-9.3,5c0.2,1.2,1.5,1.6,0.5,3.3\nc-2.2-0.5-2.9-2.2-2.8-4.6c0.1-3.8,3.4-6.5,6.7-6.9c4.2-0.5,8.1,1.5,8.6,5.5C24.2,17,21.8,21.8,17.3,21.4L17.3,21.4z"
  }));
}

export default IconPinterest;